/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { NumericQuantityDto } from './NumericQuantityDto';
import {
    NumericQuantityDtoFromJSON,
    NumericQuantityDtoFromJSONTyped,
    NumericQuantityDtoToJSON,
} from './NumericQuantityDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfNumericQuantityDto
 */
export interface ODataPostProcessedResultsOfNumericQuantityDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<NumericQuantityDto>}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    value?: Array<NumericQuantityDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    $type?: ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfNumericQuantityDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoNumericQuantityDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericQuantityDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum = typeof ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum];



/**
 * Check if a given object implements the ODataPostProcessedResultsOfNumericQuantityDto interface.
 */
export function instanceOfODataPostProcessedResultsOfNumericQuantityDto(value?: unknown): value is ODataPostProcessedResultsOfNumericQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfNumericQuantityDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfNumericQuantityDtoFromJSON(json: any): ODataPostProcessedResultsOfNumericQuantityDto {
    return ODataPostProcessedResultsOfNumericQuantityDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfNumericQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfNumericQuantityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'value': json['value'] == null ? undefined : ((json['value'] as Array<any>).map(NumericQuantityDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
        'odataCount': json['@odata.count'] == null ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfNumericQuantityDtoToJSON(value?: ODataPostProcessedResultsOfNumericQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value['totalCount'],
        'value': value['value'] == null ? undefined : ((value['value'] as Array<any>).map(NumericQuantityDtoToJSON)),
        '$type': value['$type'],
        '@odata.count': value['odataCount'],
    });
}

